import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Params {
  id: string;
  planCodeIds?: number[];
}

export const useDeactivatePayrollCalendarQuery = () => {
  const { mutateAsync, isLoading, isSuccess } = useMutation((params: Params) =>
    api.delete(API_URL.PAYROLL_CALENDARS_BY_ID(params.id), {
      data: params?.planCodeIds || [],
    })
  );
  return {
    deactivateCalendar: mutateAsync,
    isLoading,
    isSuccess,
  };
};
